import axios, { AxiosRequestConfig } from "axios";
import { SessionStorageKeys } from "common/enums";

export class HttpClient {
  static requestConfig(optionsIn?: { [index: string]: any }) {
    const options = optionsIn || {};
    const doNotCache = options.doNotCache;

    type headerType = {};

    const headers: headerType = {};

    if (doNotCache) {
      headers["Cache-Control"] = "no-cache, no-store, must-revalidate";
      headers["Pragma"] = "no-cache";
      headers["Expires"] = 0;
    }

    return {
      headers
    };
  }

  static async post<T = any>(url: string, data?: any, config?: AxiosRequestConfig) {
    const response = await axios.post<T>(url, data, {
      ...config,
      headers: {
        ...config?.headers,
        "Content-Language": sessionStorage.getItem(SessionStorageKeys.LANGUAGE) || "en"
      }
    });
    return response;
  }

  static async put<T = any>(url: string, data?: any, config?: AxiosRequestConfig) {
    const response = await axios.put<T>(url, data, {
      ...config,
      headers: {
        ...config?.headers,
        "Content-Language": sessionStorage.getItem(SessionStorageKeys.LANGUAGE) || "en"
      }
    });
    return response;
  }

  static async get<T = any>(url: string, config?: AxiosRequestConfig) {
    const response = await axios.get<T>(url, {
      ...config,
      headers: {
        ...config?.headers,
        "Content-Language": sessionStorage.getItem(SessionStorageKeys.LANGUAGE) || "en"
      }
    });
    return response;
  }

  static async delete<T = any>(url: string, config?: AxiosRequestConfig) {
    const response = await axios.request<T>({
      ...config,
      method: "delete",
      url,
      headers: {
        ...config?.headers,
        "Content-Language": sessionStorage.getItem(SessionStorageKeys.LANGUAGE) || "en"
      }
    });
    return response;
  }
}
